<template>
  <div class="mangement_create">
    <div style="margin-bottom: 10px">
      <a-button type="primary" @click="userRole=='youwei_admin'?add_batch():add(1)"> 创建考试 </a-button>
    </div>
    <div style="margin-bottom: 10px; display: flex; justify-content: space-between; width: 100%">
      <a-row type="flex">
        <a-col :flex="4" v-if="userRole == 'youwei_admin'">
          <span>所属公司：</span>
          <a-tree-select style="width: 160px; margin-right: 10px" v-model="searchInfo.companyId" allowClear
            :treeData="companyLists" :show-checked-strategy="SHOW_PARENT" placeholder="所属公司" :replaceFields="options"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1">
          </a-tree-select>
        </a-col>
        <a-col :flex="4">
          <a-input placeholder="考试名称" v-model="searchInfo.examName" style="width: 160px; margin-right: 10px" />
        </a-col>
        <a-col :flex="4">
          <a-input placeholder="考试课程" v-model="searchInfo.courseName" style="width: 160px; margin-right: 10px" />
        </a-col>
        <a-col :flex="4">
          <a-input placeholder="操作者" v-model="searchInfo.lastModifier" style="width: 160px; margin-right: 10px" />
        </a-col>
        <a-col :flex="4">
          <a-button type="primary" @click="search_lis"> 查询 </a-button>
          <a-button @click="refresh"> 重置 </a-button>
          <a-button type="primary" @click="issueBatch" :disabled="!selectRow.length"> 批量发布 </a-button>
        </a-col>
      </a-row>
    </div>
    <div style="margin-bottom: 10px; height: calc(100% - 126px)" ref="mainTable">
      <a-table :data-source="data" :scroll="{ y: tableScrollY }" :pagination="false" rowKey="id"
        :row-selection="rowSelection">
        <a-table-column title="所属公司" key="companyId" dataIndex="companyId" v-if="userRole=='youwei_admin'">
          <template slot-scope="text,record">
            {{deptObj?deptObj[record.companyId].title:''}}
          </template>
        </a-table-column>
        <a-table-column title="考试名称" key="examName" dataIndex="examName"> </a-table-column>
        <a-table-column title="考试课程" key="courseName" dataIndex="courseName"></a-table-column>
        <a-table-column title="最后操作者" key="lastModifier" dataIndex="lastModifier"></a-table-column>
        <a-table-column title="最后操作时间" key="updateTime" dataIndex="updateTime"></a-table-column>
        <a-table-column title="操作" key="id" dataIndex="id">
          <template slot-scope="text, record">
            <template v-if="record.issueFlag==0">
              <a-button type="link" @click="add(2,record)"> 编辑 </a-button>
              <a-divider type="vertical" />
              <a-button type="link" @click="exportExam(record)"> 发布 </a-button>
            </template>
            <template v-if="record.issueFlag==1">
              <a-button type="link" @click="add(3,record)"> 详情 </a-button>
            </template>
            <template v-if="userRole == 'youwei_admin'">
              <a-divider type="vertical" />
              <a-button type="link" @click="shareExam(record)"> 分享 </a-button>
            </template>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div>
      <a-pagination show-size-changer :default-current="1" :total="totalCount" :page-size.sync="searchInfo.pageSize"
        @change="onShowPageChange" show-quick-jumper />
    </div>
    <a-modal v-model="detailInfoShow" :title="addType==1?'创建考试':'考试详情'" width="60%">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
        <a-card style="width: 100%">
          <a-row>
            <a-form-item label="考试名称：" required style="margin:0">
              <a-input v-model="examForm.examName" placeholder="请输入" :disabled="addType==3"></a-input>
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item label="考试课程：" required style="margin:0">
              <template v-if="userRole == 'youwei_admin'">
                <a-select v-model="examForm.courseIdList" mode="multiple" placeholder="请选择" :filterOption="courseFilter"
                  :autoClearSearchValue="false" :disabled="addType==3">
                  <template v-for="item in addBatchCourseLis[examForm.companyId]">
                    <a-select-option :key="item.courseName" :value="Number(item.id)"
                      :class="item.issueFlag==2?'selectNoShow':''">
                      {{ item.courseName }}
                    </a-select-option>
                  </template>
                </a-select>
              </template>
              <template v-else>
                <a-select v-model="examForm.courseIdList" mode="multiple" placeholder="请选择" :filterOption="courseFilter"
                  :autoClearSearchValue="false" :disabled="addType==3">
                  <template v-for="item in course_lis">
                    <a-select-option :key="item.courseName" :value="Number(item.id)"
                      :class="item.issueFlag==2?'selectNoShow':''">
                      {{ item.courseName }}
                    </a-select-option>
                  </template>
                </a-select>
              </template>
            </a-form-item>
          </a-row>
          <a-row>
            <a-form-item label="参与人员：" required style="margin:0">
              <template v-if="userRole == 'youwei_admin'">
                <a-tree-select style="width: 100%; margin-right: 10px" v-model="examForm.userIdList" allowClear
                  :treeData="deptLists[examForm.companyId]" tree-checkable :show-checked-strategy="SHOW_PARENT"
                  placeholder="请选择" :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  maxTagCount="5">
                </a-tree-select>
              </template>
              <template v-else>
                <a-tree-select style="width: 100%; margin-right: 10px" v-model="examForm.userIdList" allowClear
                  :treeData="deptLists[userInfo.companyId]" tree-checkable :show-checked-strategy="SHOW_PARENT"
                  placeholder="请选择" :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                  maxTagCount="8">
                </a-tree-select>
              </template>
            </a-form-item>
          </a-row>
        </a-card>
        <a-card style="width: 100%;margin-top:10px;">
          <a-row>
            <a-col :span="12">
              <a-form-item label="单选：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="examForm.singleNumber" type="number" :disabled="addType==3"
                    @input="mathTotal('singleNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="examForm.singleScore" type="number" :disabled="addType==3"
                  @input="mathTotal('singleScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="多选：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="examForm.multiNumber" type="number" :disabled="addType==3"
                    @input="mathTotal('multiNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="examForm.multiScore" type="number" :disabled="addType==3"
                  @input="mathTotal('multiScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="判断：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="examForm.judgeNumber" type="number" :disabled="addType==3"
                    @input="mathTotal('judgeNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="examForm.judgeScore" type="number" :disabled="addType==3"
                  @input="mathTotal('judgeScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="总分：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="examForm.totalScore" disabled></a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合格分：" required style="margin:0">
                <a-input v-model="examForm.passScore" type="number" :disabled="addType==3"
                  @input="mathTotal('passScore')"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="detailInfoShow=false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOk">
          确认
        </a-button>
      </template>
    </a-modal>
    <a-modal v-model="addBatchVisible" :title="'创建考试'" width="60%">
      <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-card style="width: 100%">
          <a-row>
            <a-col :span="24">
              <a-form-item label="考试名称：" required style="margin:0" :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }">
                <a-input v-model="addBatchInfo.examName" placeholder="请输入"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-for="item,index in addBatchInfo.joinUserList" :key="index">
            <a-col :span="8">
              <a-form-item label="所属公司" required style="margin:0">
                <div class="flex_st_c" style="padding:6px 0">
                  <a-tree-select style="width: 160px; margin-right: 10px" v-model="item.companyId" allowClear
                    :treeData="companyLists" :show-checked-strategy="SHOW_PARENT" placeholder="所属公司"
                    :replaceFields="options" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="1"
                    @change="companyChange(item,index)">
                  </a-tree-select>
                  <a-icon type="close-circle" style="color:#f24" v-if="addBatchInfo.joinUserList.length>1"
                    @click="delBatchCompany(index)" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="考试课程：" required style="margin:0">
                <a-select v-model="item.courseIdList" mode="multiple" placeholder="请选择" :filterOption="courseFilter"
                  :autoClearSearchValue="false">
                  <template v-for="item in item.companyId?addBatchCourseLis[item.companyId]:[]">
                    <a-select-option :key="item.courseName" :value="Number(item.id)"
                      :class="item.issueFlag==2?'selectNoShow':''">
                      {{ item.courseName }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="参与人员：" required style="margin:0">
                <a-tree-select style="width: 100%; margin-right: 10px" v-model="item.userIdList" allowClear
                  :treeData="item.companyId?deptLists[item.companyId]:[]" tree-checkable
                  :show-checked-strategy="SHOW_PARENT" placeholder="请选择" :replaceFields="options"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="5">
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-button type="primary" style="margin-top:10px;" @click="addBatchCompany">添加考试公司</a-button>
        </a-card>
        <a-card style="width: 100%;margin-top:10px;">
          <a-row>
            <a-col :span="12">
              <a-form-item label="单选：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="addBatchInfo.singleNumber" type="number" @input="batchMath('singleNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="addBatchInfo.singleScore" type="number" @input="batchMath('singleScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="多选：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="addBatchInfo.multiNumber" type="number" @input="batchMath('multiNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="addBatchInfo.multiScore" type="number" @input="batchMath('multiScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="判断：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="addBatchInfo.judgeNumber" type="number" @input="batchMath('judgeNumber')">
                  </a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="分值：" style="margin:0">
                <a-input v-model="addBatchInfo.judgeScore" type="number" @input="batchMath('judgeScore')">
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item label="总分：" style="margin:0">
                <div class="flex_c_c" style="width:100%">
                  <a-input v-model="addBatchInfo.totalScore" disabled></a-input>
                  <span style="margin-left:6px;">题</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="合格分：" required style="margin:0">
                <a-input v-model="addBatchInfo.passScore" type="number" @input="batchMath('passScore')"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="addBatchVisible=false">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="addBatchSubmit">
          确认
        </a-button>
      </template>
    </a-modal>
    <a-modal v-model="shareExamVisible" :title="'考试分享'" width="80%">
      <a-form v-if="shareExamVisible" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="6">
            <a-form-item label="考试名称：" style="margin:0">
              <span>{{shareExamInfo.examName}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="所属公司：" style="margin:0">
              <span>
                {{deptObj?deptObj[shareExamInfo.companyId].title:''}}
              </span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="考试课程：" style="margin:0">
              <span>{{shareExamInfo.courseName}}</span>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="参与人员：" style="margin:0">
              <span>{{shareExamInfo.joinUserName}}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-card style="width: 100%">
          <a-row v-for="item,index in shareExamLis" :key="index">
            <a-col :span="6">
              <a-form-item label="所属公司" required style="margin:0">
                <div class="flex_st_c" style="padding:6px 0;">
                  <a-input v-model="item.companyName" readonly></a-input>
                  <a-icon type="close-circle" style="color:#f24;margin-left:10px;" v-if="shareExamLis.length>1"
                    @click="delShareCompany(index)" />
                </div>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="考试课程：" required style="margin:0">
                <a-select v-model="item.courseIdList" mode="multiple" placeholder="请选择" :filterOption="courseFilter"
                  :autoClearSearchValue="false">
                  <template v-for="item in item.companyId?addBatchCourseLis[item.companyId]:[]">
                    <a-select-option :key="item.courseName" :value="Number(item.id)"
                      :class="item.issueFlag==2?'selectNoShow':''">
                      {{ item.courseName }}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item label="参与人员：" required style="margin:0">
                <a-tree-select style="width: 100%; margin-right: 10px" v-model="item.userIdList" allowClear
                  :treeData="item.companyId?deptLists[item.companyId]:[]" tree-checkable
                  :show-checked-strategy="SHOW_PARENT" placeholder="请选择" :replaceFields="options"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" maxTagCount="5">
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-card>
      </a-form>
      <template slot="footer">
        <a-button key="back" @click="shareExamVisible=false">
          取消
        </a-button>
        <a-button key="submit" type="primary" @click="shareExamSubmit">
          确认
        </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { number } from 'echarts'
import {
  getExamList, getCourseInfoList, getCompanyUsers, customizeExam,
  editExam, issueExamInfo, editExamUser, getCompanyCourseInfoList, issueExamInfoBatch,
  getTrainCategoryList, getbatchCompanyUsers, getCompanyCourseInfoLists
} from '../../../api/course'
import { tree_all } from '../../../api/purchase'
export default {
  data() {
    return {
      searchInfo: {
        companyId: undefined,
        examName: undefined,
        courseName: undefined,
        lastModifier: undefined,
        pageIndex: 1,
        pageSize: 10, // 每页条数
      },
      totalCount: 0,
      data: [],
      tableScrollY: '',
      allCourseLis: [],
      categoryList: [],
      detailInfoShow: false,
      addType: 1,
      course_lis: [],
      examForm: {
        examName: '',     // 考试名称
        courseIdList: [], // 课程id集合
        userIdList: [],   // 考试用户id集合
        singleNumber: '', // 单选题数量
        singleScore: '',  // 单选题分值
        multiNumber: '',  // 多选题数量
        multiScore: '',   // 多选题分值
        judgeNumber: '',  // 判断题数量
        judgeScore: '',   // 判断题分值
        totalScore: '',   // 总分
        passScore: '',    // 合格分
      },
      userLists: [],
      userIdLists: {},
      targetKeys: [],
      selectUser: '',
      selectUserVisible: false,
      selectUseIds: [],

      deptLists: {},
      options: {
        children: 'children',
        title: 'title',
        key: 'deptId',
        value: 'value',
      },
      userInfo: {},
      userRole: '',
      companyLists: [],
      deptObj: '',

      addBatchInfo: {},
      addBatchVisible: false,
      addBatchCourseLis: {},
      selectRow: [],
      selectedRowKeys: [],

      shareExamVisible: false,
      shareExamInfo: {},
      shareExamLis: [],
    }
  },
  mounted() {
    this.userInfo = this.$store.getters.userInfo
    this.getUsers(this.userInfo.companyId)
    this.get_lis()
    this.$nextTick((res) => {
      this.tableScrollY = this.$refs.mainTable.offsetHeight - 54
    })
    for (let i = 0; i < this.userInfo.roles.length; i++) {
      if (this.userInfo.roles[i].roleKey == "youwei_admin") {
        this.userRole = 'youwei_admin'
      }
    }
  },
  computed: {
    rowSelection() {
      let selectedRowKeys = this.selectedRowKeys
      return {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectRow = selectedRows
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.issueFlag !== 0, // Column configuration not to be checked
          },
        }),
      }
    }
  },
  methods: {
    delShareCompany(index) {
      this.shareExamLis.splice(index, 1)
    },
    shareExamSubmit() {
      let request_lis = []
      for (let i = 0; i < this.shareExamLis.length; i++) {
        if (this.shareExamLis[i].courseIdList && this.shareExamLis[i].courseIdList.length && this.shareExamLis[i].userIdList && this.shareExamLis[i].userIdList.length) {
          request_lis.push(new Promise((reslove, reject) => {
            customizeExam(this.shareExamLis[i]).then(res => {
              reslove(res)
            })
          }))
        } else {
          return this.$message.error('考试课程或参与人员不能为空，添加失败')
        }
      }
      Promise.all(request_lis).then(res => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].code != 200) {
            this.get_lis()
            return this.$message.error(res[i].msg)
          }
        }
        this.$message.success('新增成功')
        this.shareExamVisible = false
        this.get_lis()
      })

    },
    shareExam(row) {
      let _this = this
      let shareExamInfo = {
        examName: row.examName,
        companyId: Number(row.companyId),
        courseName: row.courseName,
        userIdList: row.userIds.split(',') || [],
        joinUserName: '',
      }
      this.getUsers(row.companyId, () => {
        let rel_user_lis = JSON.parse(JSON.stringify(this.deptLists[row.companyId]))
        let selectUserIds = shareExamInfo.userIdList
        let selectDeptName = []
        function getDeptName(list, parentName) {
          let userIds = []
          userIds = _this.getDeptUser(list, userIds)
          let num = 0
          for (let j = 0; j < userIds.length; j++) {
            if (selectUserIds.includes(String(userIds[j]))) {
              num += 1
            }
          }
          if (num && num == userIds.length && parentName) {
            selectDeptName.push(parentName)
          } else {
            for (let i = 0; i < list.length; i++) {
              if (list[i].children) {
                getDeptName(list[i].children, list[i].title)
              } else {
                if (selectUserIds.includes(list[i].userId)) {
                  selectDeptName.push(list[i].userName)
                }
              }
            }
          }
        }
        getDeptName(rel_user_lis, '')
        shareExamInfo.joinUserName = selectDeptName.join('、')
        let request_lis = []
        let shareExamLis = []
        let shareCompanyIds = []
        for (let i = 0; i < this.companyLists.length; i++) {
          if (row.companyId != this.companyLists[i].deptId) {
            shareCompanyIds.push(this.companyLists[i].deptId)
            shareExamLis.push(
              {
                companyName: this.companyLists[i].title,
                companyId: this.companyLists[i].deptId,
                examName: row.examName,     // 考试名称
                courseIdList: [], // 课程id集合
                userIdList: [],   // 考试用户id集合
                singleNumber: row.singleNumber, // 单选题数量
                singleScore: row.singleScore,  // 单选题分值
                multiNumber: row.multiNumber,  // 多选题数量
                multiScore: row.multiScore,   // 多选题分值
                judgeNumber: row.judgeNumber,  // 判断题数量
                judgeScore: row.judgeScore,   // 判断题分值
                totalScore: row.totalScore,   // 总分
                passScore: row.passScore,    // 合格分
              }
            )

          }
        }
        let courseNameLis = row.courseName.split('、')
        request_lis.push(new Promise((reslove, reject) => {
          getbatchCompanyUsers({ companyIds: shareCompanyIds.join(',') }).then(res => {
            if (res.code != 200) {
              return reslove(res)
            }
            for (let key in res.data) {
              let index = shareCompanyIds.indexOf(Number(key))
              let deptLists = JSON.parse(JSON.stringify(_this.deptObj[key].children))
              function formatDeptId(list) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].children && list[i].children.length) {
                    formatDeptId(list[i].children)
                  } else {
                    delete list[i].children
                  }
                  list[i].deptId = '_' + list[i].deptId
                  list[i].key = list[i].deptId
                  list[i].value = list[i].deptId
                }
              }
              formatDeptId(deptLists)
              let userIdLists = {}
              let deptIdObj = {}
              for (let i = 0; i < res.data[key].length; i++) {
                res.data[key][i].key = Number(res.data[key][i].userId)
                res.data[key][i].title = res.data[key][i].userName
                res.data[key][i].value = Number(res.data[key][i].userId)
                userIdLists[res.data[key][i].userId] = res.data[key][i]
                if (!deptIdObj['_' + res.data[key][i].deptId]) {
                  deptIdObj['_' + res.data[key][i].deptId] = []
                }
                deptIdObj['_' + res.data[key][i].deptId].push(res.data[key][i])
              }
              function addUser(list) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].children && list[i].children.length) {
                    addUser(list[i].children)
                  }
                  if (deptIdObj[list[i].deptId]) {
                    if (!list[i].children || !list[i].children.length) {
                      list[i].children = []
                    }
                    deptIdObj[list[i].deptId].forEach(item => {
                      item.deptId = item.userId
                      list[i].children.push(item)
                    })
                  }
                }
              }
              addUser(deptLists)
              function deleteChildren(list) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].parentId == 141) {
                  }
                  if ((!list[i].children || (list[i].children && !list[i].children.length)) && !list[i].userName) {
                    list.splice(i, 1)
                    i--
                    if (list.length == 0) {
                      return true
                    }
                  } else if (list[i].children && list[i].children.length) {
                    if (deleteChildren(list[i].children)) {
                      list.splice(i, 1)
                      i--
                    }
                  }
                }
              }
              deleteChildren(deptLists)
              _this.deptLists[key] = deptLists
              let userIdList = []
              function addExamUser(list) {
                for (let i = 0; i < list.length; i++) {
                  if (list[i].children) {
                    addExamUser(list[i].children)
                  } else {
                    userIdList.push(Number(list[i].userId))
                  }
                }
              }
              function findExamDept(list) {
                for (let i = 0; i < list.length; i++) {
                  if (selectDeptName.includes(list[i].title)) {
                    list[i].children && addExamUser(list[i].children)
                  } else if (list[i].children) {
                    findExamDept(list[i].children)
                  }
                }
              }
              findExamDept(deptLists)
              shareExamLis[index].userIdList = userIdList
            }
            reslove(res)
          })
        }))
        request_lis.push(new Promise((reslove, reject) => {
          getCompanyCourseInfoLists({ companyIds: shareCompanyIds.join(',') }).then(res => {
            if (res.code != 200) {
              return reslove(res)
            }
            for (let key in res.data) {
              _this.addBatchCourseLis[key] = res.data[key]
              let index = shareCompanyIds.indexOf(Number(key))
              let courseIdList_new = []
              for (let i = 0; i < res.data[key].length; i++) {
                if (courseNameLis.includes(res.data[key][i].courseName)) {
                  courseIdList_new.push(Number(res.data[key][i].id))
                }
              }
              shareExamLis[index].courseIdList = courseIdList_new
            }
            reslove(res)
          })
        }))
        Promise.all(request_lis).then(res => {
          for (let i = 0; i < res.length; i++) {
            if (res[i].code != 200) {
              return this.$message.error(res[i].msg)
            }
          }
          this.shareExamInfo = shareExamInfo
          this.shareExamLis = shareExamLis
          this.shareExamVisible = true
        })
      })
    },
    delBatchCompany(index) {
      this.addBatchInfo.joinUserList.splice(index, 1)
    },
    issueBatch() {
      this.$confirm({
        title: '提示',
        content: '确认发布已选考试?',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          issueExamInfoBatch(this.selectRow).then(res => {
            if (res.code != 200) {
              return this.$message.error(res.msg)
            }
            this.$message.success('发布成功')
            this.selectedRowKeys = []
            this.get_lis()
          })
        },
        onCancel() {
        },
      })
    },
    getDeptUser(list, userIds) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].children) {
          this.getDeptUser(list[i].children, userIds)
        } else {
          if (!userIds.includes(list[i].userId)) {
            userIds.push(Number(list[i].userId))
          }
        }
      }
      return userIds
    },
    companyChange(item, index) {
      let _this = this
      item.courseIdList = []
      item.userIdList = []
      if (item.companyId) {
        this.getCompanyUsers(item.companyId, (res) => {
          if (index) {
            if (this.addBatchInfo.joinUserList[0].companyId || this.addBatchInfo.joinUserList[0].userIdList) {
              let rel_companyId = this.addBatchInfo.joinUserList[0].companyId
              let rel_user_lis = JSON.parse(JSON.stringify(this.deptLists[rel_companyId]))
              let selectUserIds = this.addBatchInfo.joinUserList[0].userIdList
              let selectDeptName = []
              function getDeptName(list, parentName) {
                let userIds = []
                userIds = _this.getDeptUser(list, userIds)
                let num = 0
                for (let j = 0; j < userIds.length; j++) {
                  if (selectUserIds.includes(userIds[j])) {
                    num += 1
                  }
                }
                if (num && num == userIds.length) {
                  selectDeptName.push(parentName)
                }
                for (let i = 0; i < list.length; i++) {
                  if (list[i].children) {
                    getDeptName(list[i].children, parentName + '/' + list[i].title)
                  }
                }
              }
              getDeptName(rel_user_lis, '')
              let joinUserList = []
              let user_lis = this.deptLists[item.companyId]
              function getjoinUserLis(list, parentName) {
                for (let i = 0; i < list.length; i++) {
                  if (selectDeptName.includes(parentName + '/' + list[i].title)) {
                    _this.getDeptUser(list[i].children, joinUserList)
                  } else {
                    if (list[i].children) {
                      getjoinUserLis(list[i].children, parentName + '/' + list[i].title)
                    }
                  }
                }
              }
              getjoinUserLis(user_lis, '')
              item.userIdList = joinUserList
            }
          }
        })
        this.getCourseLis(item.companyId, item)
      }
    },
    getCourseLis(companyId, item) {
      getCompanyCourseInfoList({ companyId: companyId }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].id = Number(res.data[i].id)
        }
        this.addBatchCourseLis[companyId] = res.data
        if (item) {
          if (this.addBatchInfo.joinUserList[0] && this.addBatchInfo.joinUserList[0].companyId) {
            let courseNameLis = []
            let courseIdList = this.addBatchInfo.joinUserList[0].courseIdList
            for (let i = 0; i < this.addBatchCourseLis[this.addBatchInfo.joinUserList[0].companyId].length; i++) {
              let course_item = this.addBatchCourseLis[this.addBatchInfo.joinUserList[0].companyId][i]
              if (courseIdList.includes(Number(course_item.id))) {
                if (!courseNameLis.includes(course_item.courseName)) {
                  courseNameLis.push(course_item.courseName)
                }
              }
            }
            let courseIdList_new = []
            for (let i = 0; i < res.data.length; i++) {
              if (courseNameLis.includes(res.data[i].courseName)) {
                courseIdList_new.push(Number(res.data[i].id))
              }
            }
            item.courseIdList = courseIdList_new
          }
        }
      })
    },
    addBatchCompany() {
      this.addBatchInfo.joinUserList.push({
        companyId: undefined,
        courseIdList: [], // 课程id集合
        userIdList: [],   // 考试用户id集合
      })
    },
    addBatchSubmit() {
      let addBatchInfo = JSON.parse(JSON.stringify(this.addBatchInfo))
      if (!addBatchInfo.examName) {
        return this.$message.error('请输入考试名称')
      } else if (!addBatchInfo.passScore) {
        return this.$message.error('请输入合格分')
      }
      let arr = ['singleNumber', 'singleScore', 'multiNumber', 'multiScore', 'judgeNumber', 'judgeScore', 'totalScore', 'passScore',]
      arr.forEach(item => {
        addBatchInfo[item] = Number(addBatchInfo[item])
      })
      let request_lis = []
      for (let i = 0; i < addBatchInfo.joinUserList.length; i++) {
        if (!addBatchInfo.joinUserList[i].courseIdList || !addBatchInfo.joinUserList[i].courseIdList.length) {
          return this.$message.error('请选择考试课程')
        } else if (!addBatchInfo.joinUserList[i].userIdList || !addBatchInfo.joinUserList[i].userIdList.length) {
          return this.$message.error('请选择参与人员')
        }
        let params = {
          companyId: addBatchInfo.joinUserList[i].companyId,
          examName: addBatchInfo.examName,     // 考试名称
          courseIdList: addBatchInfo.joinUserList[i].courseIdList, // 课程id集合
          userIdList: addBatchInfo.joinUserList[i].userIdList,   // 考试用户id集合
          singleNumber: addBatchInfo.singleNumber, // 单选题数量
          singleScore: addBatchInfo.singleScore,  // 单选题分值
          multiNumber: addBatchInfo.multiNumber,  // 多选题数量
          multiScore: addBatchInfo.multiScore,   // 多选题分值
          judgeNumber: addBatchInfo.judgeNumber,  // 判断题数量
          judgeScore: addBatchInfo.judgeScore,   // 判断题分值
          totalScore: addBatchInfo.totalScore,   // 总分
          passScore: addBatchInfo.passScore,    // 合格分
        }
        request_lis.push(new Promise((reslove, reject) => {
          customizeExam(params).then(res => {
            reslove(res)
          })
        }))
      }
      Promise.all(request_lis).then(res => {
        for (let i = 0; i < res.length; i++) {
          if (res[i].code != 200) {
            this.get_lis()
            return this.$message.error(res[i].msg)
          }
        }
        this.$message.success('新增成功')
        this.addBatchVisible = false
        this.get_lis()
      })
    },
    add_batch() {
      this.addBatchInfo = {
        joinUserList: [{
          companyId: undefined,
          courseIdList: [], // 课程id集合
          userIdList: [],   // 考试用户id集合
        }],
        examName: undefined,     // 考试名称
        singleNumber: undefined, // 单选题数量
        singleScore: undefined,  // 单选题分值
        multiNumber: undefined,  // 多选题数量
        multiScore: undefined,   // 多选题分值
        judgeNumber: undefined,  // 判断题数量
        judgeScore: undefined,   // 判断题分值
        totalScore: undefined,   // 总分
        passScore: undefined,    // 合格分
      }
      this.addBatchVisible = true
    },
    // 考试发布
    exportExam(row) {
      this.$confirm({
        title: '提示',
        content: '是否确认发布此考试?',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          issueExamInfo(row).then(res => {
            if (res.code != 200) {
              return this.$message.error(res.msg)
            }
            this.$message.success('发布成功')
            this.get_lis()
          })
        },
        onCancel() {
        },
      })
    },
    batchMath(type) {
      if (!/^[0-9]*$/.test(this.addBatchInfo[type])) {
        this.addBatchInfo[type] = ''
      }
      this.addBatchInfo.totalScore = Number((this.addBatchInfo.singleNumber || 0) * (this.addBatchInfo.singleScore || 0) + (this.addBatchInfo.multiNumber || 0) * (this.addBatchInfo.multiScore || 0) + (this.addBatchInfo.judgeNumber || 0) * (this.addBatchInfo.judgeScore || 0))
    },
    // 计算总分
    mathTotal(type) {
      if (!/^[0-9]*$/.test(this.examForm[type])) {
        this.examForm[type] = ''
      }
      this.examForm.totalScore = Number((this.examForm.singleNumber || 0) * (this.examForm.singleScore || 0) + (this.examForm.multiNumber || 0) * (this.examForm.multiScore || 0) + (this.examForm.judgeNumber || 0) * (this.examForm.judgeScore || 0))
    },
    renderItem(item) {
      let customLabel = <span class="custom-item">{item.title}</span>
      return {
        label: customLabel,
        value: item.key,
      }
    },
    handleSearch(dir, value) { },
    // 搜索
    courseFilter(inputValue, option) {
      return option.key.indexOf(inputValue) > -1
    },
    filterOption(inputValue, option) {
      return option.userName.indexOf(inputValue) > -1
    },
    handleChange(targetKeys, direction, moveKeys) {
      this.examForm.userIdList = targetKeys
    },
    // 新增
    handleOk() {
      let params = JSON.parse(JSON.stringify(this.examForm))
      if (!params.examName) {
        return this.$message.error('请输入考试名称')
      } else if (!params.courseIdList.length) {
        return this.$message.error('请选择考试课程')
      } else if (!params.userIdList.length) {
        return this.$message.error('请选择参与人员')
      } else if (!params.passScore) {
        return this.$message.error('请输入合格分')
      }
      let arr = ['singleNumber', 'singleScore', 'multiNumber', 'multiScore', 'judgeNumber', 'judgeScore', 'totalScore', 'passScore',]
      arr.forEach(item => {
        params[item] = Number(params[item])
      })
      if (this.addType == 1) {
        customizeExam(params).then(res => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('新增成功')
          this.detailInfoShow = false
          this.get_lis()
        })
      } else if (this.addType == 2) {
        editExam(params).then(res => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          this.detailInfoShow = false
          this.get_lis()
        })
      } else if (this.addType == 3) {
        editExamUser(params).then(res => {
          if (res.code != 200) {
            return this.$message.error(res.msg)
          }
          this.$message.success('保存成功')
          this.detailInfoShow = false
          this.get_lis()
        })
      }
    },
    handleCancel() { },
    search_lis() {
      this.searchInfo.pageIndex = 1
      this.get_lis()
    },
    // 新增或编辑框显示
    add(type, row) {
      this.addType = type || 1
      let examForm = JSON.parse(JSON.stringify(row || {}))
      if (this.addType == 1) {
        examForm.examName = ''// 考试名称
        examForm.courseIdList = []// 课程id集合
        examForm.userIdList = []// 考试用户id集合
        examForm.singleNumber = ''// 单选题数量
        examForm.singleScore = ''// 单选题分值
        examForm.multiNumber = ''// 多选题数量
        examForm.multiScore = ''// 多选题分值
        examForm.judgeNumber = ''// 判断题数量
        examForm.judgeScore = ''// 判断题分值
        examForm.totalScore = ''// 总分
        examForm.passScore = ''// 合格分
      } else {
        let userIdList = row.userIds ? row.userIds.split(',') : []
        for (let i = 0; i < userIdList.length; i++) {
          userIdList[i] = Number(userIdList[i])
        }
        examForm.companyId = row.companyId// 公司Id
        examForm.examName = row.examName// 考试名称
        examForm.courseIdList = []// 课程id集合
        examForm.userIdList = userIdList// 考试用户id集合
        examForm.singleNumber = row.singleNumber// 单选题数量
        examForm.singleScore = row.singleScore// 单选题分值
        examForm.multiNumber = row.multiNumber// 多选题数量
        examForm.multiScore = row.multiScore// 多选题分值
        examForm.judgeNumber = row.judgeNumber// 判断题数量
        examForm.judgeScore = row.judgeScore// 判断题分值
        examForm.totalScore = row.totalScore// 总分
        examForm.passScore = row.passScore// 合格分
      }
      this.examForm = examForm
      this.getCourse(row ? row.id : '', row ? row.companyId : '')
      if (this.userRole == 'youwei_admin') {
        this.getUsers(row.companyId)
        this.getCourseLis(row.companyId)
      }
      this.detailInfoShow = true
    },
    // 获取成员列表
    getUsers(companyId, cb) {
      tree_all().then((res) => {
        let _this = this
        let deptObj = {}
        let data = res.data[0]
        for (let i = 0; i < data.length; i++) {
          deptObj[data[i].deptId] = data[i]
        }
        this.deptObj = JSON.parse(JSON.stringify(deptObj))
        if (this.userRole == "youwei_admin") {
          function formatDept(lists) {
            for (let i = 0; i < lists.length; i++) {
              if (!_this.userInfo.userPermissions.includes(lists[i].deptId) && !_this.userInfo.userPermissions.includes(String(lists[i].deptId))) {
                lists.splice(i, 1)
                i--
              } else if (lists[i].children && lists[i].children.length) {
                delete lists[i].children
              }
            }
          }
          formatDept(data)
          this.companyLists = data
        }
        this.getCompanyUsers(companyId, cb)
      })
    },
    getCompanyUsers(companyId, cb) {
      let deptLists = JSON.parse(JSON.stringify(this.deptObj[companyId].children))
      function formatDeptId(list) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].children && list[i].children.length) {
            formatDeptId(list[i].children)
          } else {
            delete list[i].children
          }
          list[i].deptId = '_' + list[i].deptId
          list[i].key = list[i].deptId
          list[i].value = list[i].deptId
        }
      }
      formatDeptId(deptLists)
      getCompanyUsers({ companyId: companyId }).then((res) => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        let userIdLists = {}
        let deptIdObj = {}
        for (let i = 0; i < res.data.length; i++) {
          res.data[i].key = Number(res.data[i].userId)
          res.data[i].title = res.data[i].userName
          res.data[i].value = Number(res.data[i].userId)
          //   res.data[i].disabled = this.selectUseIds.includes(res.data[i].userId)
          userIdLists[res.data[i].userId] = res.data[i]
          if (!deptIdObj['_' + res.data[i].deptId]) {
            deptIdObj['_' + res.data[i].deptId] = []
          }
          deptIdObj['_' + res.data[i].deptId].push(res.data[i])
        }
        function addUser(list) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].children && list[i].children.length) {
              addUser(list[i].children)
            }
            if (deptIdObj[list[i].deptId]) {
              if (!list[i].children || !list[i].children.length) {
                list[i].children = []
              }
              deptIdObj[list[i].deptId].forEach(item => {
                item.deptId = item.userId
                list[i].children.push(item)
              })
            }
          }
        }
        addUser(deptLists)
        function deleteChildren(list) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].parentId == 141) {
            }
            if ((!list[i].children || (list[i].children && !list[i].children.length)) && !list[i].userName) {
              list.splice(i, 1)
              i--
              if (list.length == 0) {
                return true
              }
            } else if (list[i].children && list[i].children.length) {
              if (deleteChildren(list[i].children)) {
                list.splice(i, 1)
                i--
              }
            }
          }
        }
        deleteChildren(deptLists)
        this.deptLists[companyId] = deptLists
        this.$forceUpdate()
        cb && cb()
      })
    },
    // 获取课程列表
    getCourse(id, companyId) {
      getCourseInfoList({ examId: id, companyId: companyId }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg)
        }
        let courseIdList = []
        res.data.forEach(item => {
          if (item.checked === 0) {
            courseIdList.push(Number(item.id))
          }
        })
        this.examForm.courseIdList = courseIdList
        this.course_lis = res.data
      })
    },
    // 刷新数据
    refresh() {
      this.searchInfo = {
        companyId: undefined,
        examName: undefined,
        courseName: undefined,
        lastModifier: undefined,
        pageIndex: 1,
        pageSize: 10, // 每页条数
      }
      this.get_lis()
    },
    // 获取数据
    get_lis() {
      getExamList(this.searchInfo).then((res) => {
        if (res.code != 200) {
          return
        }
        this.data = res.data.list
        this.totalCount = res.data.totalCount
      })
    },
    onShowPageChange(page, pageSize) {
      this.searchInfo.pageIndex = page
      this.get_lis()
    },
  },
}
</script>

<style scoped lang="less">
.mangement_create {
  width: 100%;
  height: 100%;
  padding: 10px 0;
  /deep/ .ant-btn-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  /deep/ .ant-divider {
    background: #1890ff;
  }
  /deep/ .ant-dropdown-trigger {
    width: 100%;
    white-space: pre-wrap;
    display: flex;
    align-items: center;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border: 0;
    background: transparent;
  }
  /deep/ .ant-form-item {
    margin-bottom: 0;
  }
}
</style>